<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { faArrowRightLong } from '@fortawesome/duotone-regular-svg-icons'
import Button from '~/components/ui/Button.vue'

const { t } = useI18n()
const href = import.meta.env.VITE_WEBSHOP_BARNESKOLE
</script>

<template>
  <div class="relative flex flex-col items-center">
    <img
      src="../../assets/images/klover.svg"
      alt=""
      class="z-10 -mb-4 size-64"
    >
    <article class="bg-seagreen-60 text-seagreen-5 flex w-80 -rotate-3 flex-col gap-2 rounded-lg p-6">
      <p class="text-lg font-semibold" v-text="t('login.trialHeading')" />
      <p class="mb-3" v-text="t('login.trialText')" />
      <Button
        :href
        target="_blank"
        center
        color="yellow"
        class="bg-(--color-yellow-40) text-(--color-green-60) hover:not-disabled:bg-(--color-yellow-50) hover:not-disabled:text-(--color-green-50)"
      >
        {{ t('login.trialCta') }}
        <font-awesome-icon :icon="faArrowRightLong" />
      </Button>
    </article>
  </div>
</template>
